module.exports = __webpack_public_path__ + "static/media/i-ln.de6afd0e.svg";